import React from 'react'
import { graphql } from 'gatsby';
import Layout from '../layouts/layout'

class Index extends React.Component {
  render() {
    return (
      <Layout isWhite>
        <div style = { { padding: '20px' } } dangerouslySetInnerHTML = { { __html: this.props.data.allPrismicTcsOfTrade.edges[0].node.data.content.html } } />
      </Layout>
    )
  }
}

export const query = graphql`
    query GetTermsAndConditionsTradeContent {
        allPrismicTcsOfTrade {
            edges {
                node {
                    data {
                        content {
                            html
                        }
                    }
                }
            }
        }
    }`;

export default Index
